import FaqItems from '@/components/cms/FaqItems';

const FaqItemsWrapper = ({ blok }) => {
  const { items, title, notFoundTitle } = blok;

  return <FaqItems title={title} items={items} notFoundTitle={notFoundTitle} />;
};

export default FaqItemsWrapper;
